module.exports = __webpack_public_path__ + "static/media/mollo_1_filter.acfbdfc0.png";